$mol_speck $mol_view
	attr *
		^
		mol_theme <= theme \$mol_theme_accent
	style *
		^
		minHeight \1em
	sub /
		<= value null
